import React, { useState } from 'react'
import { Button, notification } from 'antd'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { enqueueReport, ReportApiError, ReportKey } from '../../Utils/reportsApi'

export const REPORT_HISTORY_PATH = '/accounting/reports'

/**
 * Encola un reporte de Gestión (`POST v3/gestion/reports`) y avisa al usuario
 * que le llegará por correo y quedará en "Reportes descargados" por 48 h.
 */
export default function useEnqueueReport(report: ReportKey) {
    const [submitting, setSubmitting] = useState(false)
    const { token, userInfo } = useSelector((state: any) => state)
    const history = useHistory()

    const enqueue = async (params: Record<string, any> = {}) => {
        setSubmitting(true)
        try {
            const request = await enqueueReport(token, report, params)
            const email = request?.email || userInfo?.email
            const key = `report-queued-${request?.id ?? Date.now()}`
            notification.success({
                key,
                message: 'Reporte en cola',
                description: <>
                    {request?.report_label ? <><strong>{request.report_label}</strong>: </> : null}
                    Te llegará por correo{email ? <> a <strong>{email}</strong></> : null} y quedará disponible en <strong>Reportes descargados</strong> por 48 h.
                </>,
                btn: <Button type="primary" size="small" onClick={() => {
                    notification.close(key)
                    history.push(REPORT_HISTORY_PATH)
                }}>
                    Ver Reportes descargados
                </Button>,
                duration: 10
            })
            return request
        } catch (err) {
            const description = err instanceof ReportApiError
                ? err.message
                : 'Ocurrió un error inesperado al solicitar el reporte. Intenta nuevamente.'
            notification.error({
                message: 'No se pudo solicitar el reporte',
                description,
                duration: 8
            })
            return null
        } finally {
            setSubmitting(false)
        }
    }

    return { enqueue, submitting }
}
